import script from "./HorizontalMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&setup=true&lang=js"

import "./HorizontalMenu.vue?vue&type=style&index=0&id=7b25a0b7&lang=scss"

const __exports__ = script;

export default __exports__